<template>
  <v-container>
    <h1>PUBLICAÇÕES</h1>
    <v-row>
      <v-col
        cols="12"
        xs="12"
        sm="12"
        md="2"
        v-for="(item, index) in btns"
        :key="index"
      >
        <v-btn tile block large outlined :href="item.url" target="_blank">
          {{ item.name }}
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      btns: [
        {
          name: "Formulário",
          url: "https://docs.google.com/forms/d/1ztAda6-xayatW8OVZcCfop8-rQIgunLObElgKCBBWUg",
        },
        {
          name: "Planilhas",
          url: "https://unifapbr-my.sharepoint.com/:x:/g/personal/erick_silva_unifap_br/ETGvwElvWVBEtuXQ0i6d0NUBd3JAMsVqPPtnJA16iChNdQ?rtime=9XnoYxww2Ug",
        },
      ],
    };
  },
};
</script>

<style>
</style>